export default "/assets/website/images/2020.png?64f6fcc3ca9a17bb67e15ffef23bd20e";